import React from 'react'
import Lottie from 'react-lottie';
import * as animationData from './animation/Pulsing Circle.json';
import './why-choose.css'

const Bg_animation = () => {

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };
    return (
        <>
            <Lottie
                options={defaultOptions}
                // height={70}
                // width={70}
            />
        </>
    )
}

export default Bg_animation